import React, { memo, useState } from "react";
import { ReactComponent as Chevron } from "../../../../../assets/svg/chevron.svg";
import { ReactComponent as SearchIcon } from "../../../../../assets/svg/search.svg";
import { Scrollbars } from "react-custom-scrollbars";
import "./CustomDropdown.scss";

const CustomDropdown = memo(({ name, options, value, className, onChange, isDisabled, isSearchable, ...props }) => {
    const initialState = () => {
        // console.log("dsfsfsf", props.expandByDefault);
        return props.expandByDefault ? true : false;
    };
    const [expand, updateExpand] = useState(initialState);
    const [search, updateSearch] = useState("");

    const getDropdown = () => {
        let optionsToBeRendered = options;
        if (isSearchable && search.trim() !== "") {
            optionsToBeRendered = [];
            options.forEach((o) => {
                if (o.label.toLowerCase().indexOf(search.toLowerCase().trim()) > -1) {
                    optionsToBeRendered.push(o);
                }
            });
        }
        return (
            <div className="options" style={{ height: optionsToBeRendered.length > 7 ? "150px" : "max-content" }}>
                {optionsToBeRendered.length > 7 ? <Scrollbars autoHide>{getOptions(optionsToBeRendered)}</Scrollbars> : getOptions(optionsToBeRendered)}
            </div>
        );
    };

    const getOptions = (optionsToBeRendered) => {
        return optionsToBeRendered.map((option) => {
            const isSelected = option.value === value;
            const isOptionDisabled = option.disabled;
            return (
                <div
                    key={option.value}
                    className={`option ${!isOptionDisabled && isSelected ? "active" : ""} ${isOptionDisabled ? "disabled" : ""} ${
                        props.chartType == "dashboard" ? "dashboard" : ""
                    }`}
                    onClick={async () => {
                        if (isOptionDisabled) return;

                        await onChange(option.value);
                        await updateExpand(false);
                    }}>
                    <span>{option.label}</span>
                </div>
            );
        });
    };

    const handleSearch = (e) => {
        updateSearch(e.target.value);
    };

    return (
        <div className={`custom-dropdown ${className ? className : ""}`}>
            <div className="header" onClick={() => updateExpand(!expand)}>
                <span>{name}</span>
                <span className={`expand-button ${expand ? "expanded" : ""}`}>
                    <Chevron />
                </span>
            </div>

            {!isDisabled && expand && (
                <>
                    {isSearchable && (
                        <div className="dropdown-search">
                            <span className="search-icon">
                                <SearchIcon />
                            </span>
                            <input type="text" placeholder="Search" value={search} onChange={handleSearch} />
                        </div>
                    )}
                    {getDropdown()}
                </>
            )}
        </div>
    );
});

export default CustomDropdown;
